import { render, staticRenderFns } from "./msLiveList.vue?vue&type=template&id=4b665b52&scoped=true"
import script from "./msLiveList.vue?vue&type=script&lang=js"
export * from "./msLiveList.vue?vue&type=script&lang=js"
import style0 from "./msLiveList.vue?vue&type=style&index=0&id=4b665b52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b665b52",
  null
  
)

export default component.exports